import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import api from "services/api";
import { promptAlertMessage } from "store/slices/alert";
import serveRequestErrors from "common/serve-request-errors";
import AppButton from "components/app-button";

export const AppConfirmDeleteTemplateModal = (props, ref) => {
    const dispatch = useDispatch();
    const [id, setId] = useState();
    const [visible, setVisible] = useState(false);
    const [isSubmiting, setIsSubmiting] = useState(false);

    const onHandleShow = useCallback((data) => {
        setId(data);
        setVisible(true);
    }, []);

    const onHandleDismiss = useCallback(() => {
        setVisible(false);
    }, []);

    //prettier-ignore
    const onHandleConfirm = useCallback(async (values) => {
        let response = null;

        setIsSubmiting(true);

        try {
            await api.post.reminderTemplate.delete(id);
            response = true;
        } catch (error) {
            serveRequestErrors(error);
        } finally {
            setIsSubmiting(false);
        }

        if (response) {
            onHandleDismiss();
            dispatch(promptAlertMessage({ message: "Template has been deleted successfully" }));
            props.onHandleGetList()
        }
    }, [dispatch, onHandleDismiss, id, props]);

    //prettier-ignore
    useImperativeHandle(ref, () => ({
        onHandleShow: onHandleShow,
        onHandleDismiss: onHandleDismiss,
    }));

    return (
        <Modal classes={{ root: "app-confirm-delete-template-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="confirm-delete-template-modal" aria-describedby="confirm-delete-template-modal">
            <div className="confirm-delete-template-modal">
                <div className="confirm-delete-template-modal__main">
                    <div className="confirm-delete-template-modal__header">
                        <p className="confirm-delete-template-modal__title">Confirm Template Deletion</p>
                        <p className="confirm-delete-template-modal__description">
                            Are you sure you want to delete this reminder template?
                            This will soft delete the template, so it can no longer be used for new assignments.
                            Existing assignments that already use this template will remain unchanged. </p>
                    </div>

                    <div className="confirm-delete-template-modal__body">

                        <div className="confirm-delete-template-modal__button-container">
                            <AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} disabled={isSubmiting} />
                            <AppButton type="submit" label="Confirm" onClick={onHandleConfirm} disabled={isSubmiting} />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default memo(forwardRef(AppConfirmDeleteTemplateModal));

AppConfirmDeleteTemplateModal.propTypes = {
    ref: PropTypes.object,
};
